export default "__VITE_ASSET__D3Jsogbn__"